import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import faceDetection from '../../Assets/Projects/face_detector.png'
import Particle from "../Particle";
import ToDoList from "../../Assets/Projects/to-do-list.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Projects </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Energy Ray"
              description="This is my one of projects in freelance, there is website about LLC Energy Ray, it's built on html, js and css"
              demoLink="https://enrgyray.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Energy Solar Estate"
              description="This is website created by me, it's built on html, js and css, and it is about LLC Solar Energy Estate"
              demoLink="https://energysolarestate.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Solar Golden Keys"
              description="This is my one of the biggest website of animations created by me, it's built on html, js and css, and it is about LLC Solar Golden Keys"
              demoLink="https://solargoldenkeys.com"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={true}
              title="Telegram Music Bot"
              description="This is my personal telegram bot created by me, bot can find music in spotify and send you links, it is built on python"
              demoLink="https://t.me/music_n1k_bot"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={faceDetection}
              isBlog={true}
              title="Telegram Face Detection Bot"
              description="This is my another telegram bot created by me, bot can find faces in your picture, it is built on python too"
              demoLink="https://t.me/FaceDetecttBot"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ToDoList}
              isBlog={false}
              title="To-do List website"
              description="This is my personal to-do list website created by me, it can save your notes, it's built on html, js and css"
              demoLink="https://to-do-list-n1k.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
